import "./Header.scss";
//import {otnLogo} from '../constants';
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
//import Login from "../containers/Login";
import config from "../config";
import { AppContext } from "../libs/contextLib";
import { useContext } from "react";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";

function Header() {
  const history = useHistory();
  const {
    isAuthenticated,
    userHasAuthenticated,
    thisUsername,
    setUsername,
    //thisSub,
    setSub,
  } = useContext(AppContext);
  
  function loggedInAs() {
    return (
      <Grid container direction="row" justifyContent="flex-end" alignItems="center">
        Logged in as&nbsp;<strong>{thisUsername}</strong>&nbsp;(<button className="buttonLink" onClick={handleLogout}>Logout</button>)
      </Grid>
    );
  }

  function support(){
    return (
      <Grid item id="contactInfo">
        <a href={"mailto:" + config.public.SUPPORT_EMAIL}>Email Support</a> or
    call{" "}
        <a href={"tel:+" + config.public.SUPPORT_PHONE.replaceAll("-", "")}>
          {config.public.SUPPORT_PHONE}
        </a>
      </Grid>
    );
  }

  async function handleLogout() {
    await Auth.signOut();
    userHasAuthenticated(false);
    setUsername(false);
    setSub(false);
    history.push("/");
  }

  return (
    <>
      <header role="banner" id="siteHeader">
        <Grid container direction="row" justifyContent="space-between">
          <Grid md={4} item>
            <div id="logoContainer">
              <Link to="/">
                <img src={config.public.LOGO} alt="logo" id="logo" />
                <div id="siteTitle">{config.TITLE}</div>
              </Link>
            </div>
          </Grid>
          <Grid item>
            <Grid item id="userInfo">
              {isAuthenticated ? loggedInAs() : false}
            </Grid>
            {config.public.SUPPORT_EMAIL ? support() : ""}
          </Grid>
        </Grid>
      </header>
    </>
  );
}

export default Header;
